<template>
  <v-dialog v-model="showPreviewDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition">
    <div  ref="imageBox"
          @mousedown="onmousedownHandle" style="position: relative;width: 100vw;height: 100vh;background-color: rgba(0, 0, 0, 0.7);overflow: hidden;">
      <!--图片-->
      <div v-if="mediaList.length>0 && mediaList[currentMediaIndex].type === 'image' && !isFullScreen"
            style="width: 100%;height: 100%;">
        <img ref="imageSource"
             height="60%"
               :src="mediaList[currentMediaIndex].url"
             style="position: absolute;"
               :style="{transform:'rotateZ('+deg+'deg) scale('+multiples+') translateX(-50%)',transformOrigin:'0 center',top:top+'px',left:left+'px',}">
      </div>
      <div v-if="mediaList.length>0 &&  mediaList[currentMediaIndex].type === 'image' && isFullScreen" style="width: 100%;height: 100%">
          <v-img height="100%"
                 width="100%"
                 contain
                 :eager="true"
                 :src="mediaList[currentMediaIndex].url"></v-img>
      </div>
      <!--视频-->
      <div style="width: 70%;margin:190px auto 0 auto;height: 100%">

        <video v-if="mediaList.length>0 && mediaList[currentMediaIndex].type === 'video'"  :src="mediaList[currentMediaIndex].url" type="video/mp4" style="height:60%;background: black;width: 100%" controls autoplay muted></video>
      </div>

    </div>
    <!--图片工具栏-->
    <div v-show="mediaList.length > 0 && mediaList[currentMediaIndex].type === 'image'" style="position: absolute;bottom: 60px;left: 50%;transform: translateX(-50%);background-color: white;width: 270px;height: 50px;border-radius: 10px;z-index: 1000">
      <div style="display: flex;justify-content: space-around;width: 100%;padding-left: 10px;padding-right: 10px">
        <!-- 旋转90度 -->
        <button @click="rotate">
          <p style="font-size:22px;color:black;cursor:pointer;line-height: 50px;text-align: center" class="iconfontFamily">&#xe64e;</p>
        </button>
        <!-- 全屏查看 -->
        <button @click="fullScreen">
          <p style="font-size:18px;cursor:pointer;line-height: 50px;text-align: center" class="iconfontFamily" :style="{'color':isFullScreen?'rgba(42, 130, 228, 1)':'black'}">&#xe624;</p>
        </button>
        <!-- 拖拽 -->
        <button @click="drag">
          <p style="font-size:23px;cursor:pointer;line-height: 50px;text-align: center" class="iconfontFamily" :style="{'color':draggable?'rgba(42, 130, 228, 1)':'black'}">&#xe672;</p>
        </button>
        <!-- 放大0.2 -->
        <button @click="magnify">
          <p style="font-size:20px;color:black;cursor:pointer;line-height: 50px;text-align: center" class="iconfontFamily">&#xe642;</p>
        </button>
        <!-- 缩小0.2 -->
        <button @click="shrink">
          <p style="font-size:20px;color:black;cursor:pointer;line-height: 50px;text-align: center" class="iconfontFamily">&#xe63b;</p>
        </button>
        <!-- 比例 -->
        <p style="font-size:16px;color:black;cursor:pointer;line-height: 50px;text-align: center;width: 50px" >{{Number(multiples*100).toFixed()}}%</p>
      </div>
    </div>
    <div style="display: flex;position: absolute;top: 32px;right: 32px;width: auto;height: auto;">
      <!--删除-->
      <div v-if="showDelete" @click="deletePic" style="width: 30px;height: 30px;border-radius: 50%;background-color:rgba(196, 196, 196, 1);margin-right: 24px">
        <p style="font-size:16px;color:black;cursor:pointer;line-height: 30px;text-align: center" class="iconfontFamily">&#xe720;</p>
      </div>
      <!--关闭-->
      <div @click="back()" style="width: 30px;height: 30px;border-radius: 50%;background-color:rgba(196, 196, 196, 1)">
        <p style="font-size:14px;color:black;cursor:pointer;line-height: 30px;text-align: center" class="iconfontFamily">&#xe60d;</p>
      </div>
    </div>
    <!--上一张-->
    <div v-show="mediaList.length > 1 && currentMediaIndex !== 0" @click="changeMediaIndex('last')" class="changePage" style="left: 10px">
      <span class="iconfontFamily changePage-icon" > &#xe633;</span>
    </div>
    <!--下一张-->
    <div v-show="mediaList.length > 1 && currentMediaIndex !== mediaList.length - 1" @click="changeMediaIndex('next')" class="changePage" style="right: 10px">
      <span class="iconfontFamily changePage-icon"> &#xe634;</span>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "PictureVideoPreviewer",
  props:['infoList','showDelete'],
  mounted() {

  },
  data(){
    return {
      loadImgClock:null,
      imageWidth:0,
      currentMediaIndex:0,
      top:0,
      left:0,
      showPreviewDialog:false,
      deg:0,
      isFullScreen:false,
      fullScreenMode:"vertical",
      fullScreenRatio:1,
      draggable:false,
      multiples:1,
      // type:'video',
      mediaList:[],
      // mediaList:[
      //   {
      //     'type':'image',
      //     'url':'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg'
      //   },
      //   {
      //     'type':'image',
      //     'url':'https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg'
      //   },
      //   {
      //     'type':'image',
      //     'url':'https://fuss10.elemecdn.com/3/28/bbf893f792f03a54408b3b7a7ebf0jpeg.jpeg'
      //   },
      //   {
      //     'type':'video',
      //     'url':'https://fuss10.elemecdn.com/2/11/6535bcfb26e4c79b48ddde44f4b6fjpeg.jpeg'
      //   },
      //   {
      //     'type':'image',
      //     'url':'https://fuss10.elemecdn.com/2/11/6535bcfb26e4c79b48ddde44f4b6fjpeg.jpeg'
      //   },
      // ],
      mouseWheelEvt: null,
      size: 0,
    }
  },
  watch:{
    showPreviewDialog(){
      if(this.showPreviewDialog){
        this.mediaList = []
        for(let i = 0;i<this.infoList.length; i++){
          this.mediaList.push(this.infoList[i])
        }
        this.currentMediaIndex = 0
        this.$nextTick(()=>{
          this.top = document.body.clientHeight*0.2
          this.left = document.body.clientWidth*0.5
          // 兼容火狐浏览器
          this.mouseWheelEvt = /Firefox/i.test(navigator.userAgent)? "DOMMouseScroll" : "mousewheel";
          // 为空间区域绑定鼠标滚轮事件 =》 处理函数是wheelHandle
          // 如果你监听了window的scroll或者touchmove事件，你应该把passive设置为true，这样滚动就会流畅很多
          this.$refs.imageBox.addEventListener(this.mouseWheelEvt, this.wheelHandle, {passive:true});
        })
      }else{
        if(this.mouseWheelEvt !== null){
          //取消监听
          this.$refs.imageBox.removeEventListener(this.mouseWheelEvt,this.wheelHandle,{passive:true});
        }
      }
    }
  },
  methods:{
    deletePic(){
      this.mediaList.splice(this.currentMediaIndex,1)
      this.$emit('removeMedia', this.mediaList);
      if(this.mediaList.length <1){
        this.back()
        this.showPreviewDialog = false
      }else if(this.currentMediaIndex ===  this.mediaList.length){
        this.currentMediaIndex = this.currentMediaIndex - 1
      }
    },
    // 放大
    magnify(){
      if(this.multiples >= 3 || this.isFullScreen){
        return
      }
      this.multiples += 0.2
    },
    // 缩小
    shrink(){
      if(this.multiples <= 0.3 || this.isFullScreen){
        return
      }
      this.multiples -= 0.2
    },
    fullScreen(){
      let verticalRatio = 1/0.6
      let horizontalRatio = this.$refs.imageBox.offsetWidth/this.$refs.imageSource.width
      if(verticalRatio > horizontalRatio){
        this.fullScreenRatio = horizontalRatio
      }else{
        this.fullScreenRatio = verticalRatio
      }
      this.top = document.body.clientHeight*0.2
      this.left = document.body.clientWidth*0.5
      this.deg = 0
      this.multiples = this.fullScreenRatio
    },

    // 旋转
    rotate(){
      if(this.isFullScreen){
        return
      }
      this.deg += 90;
      if(this.deg >= 360){
        this.deg = 0
      }
    },
    drag(){
      this.draggable = !this.draggable
      this.isFullScreen = false
    },
    onmousedownHandle(e) {
      if(!this.draggable){
        return
      }
      const that = this;
      this.$refs.imageBox.onmousemove = function (el) {
        const ev = el || window.event; // 阻止默认事件
        ev.preventDefault();
        that.left += ev.movementX;
        that.top += ev.movementY;
      };
      this.$refs.imageBox.onmouseup = function () {
        // 鼠标抬起时将操作区域的鼠标按下和抬起事件置为null 并初始化
        that.$refs.imageBox.onmousemove = null;
        that.$refs.imageBox.onmouseup = null;
      };
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        return false;
      }
    },
    wheelHandle(e) {
      // 兼容性处理 => 火狐浏览器判断滚轮的方向是属性 detail，谷歌和ie浏览器判断滚轮滚动的方向是属性 wheelDelta
      const ev = e || window.event;
      // dir = -dir; // dir > 0 => 表示的滚轮是向上滚动，否则是向下滚动 => 范围 (-120 ~ 120)
      const dir = ev.detail ? ev.detail * -120 : ev.wheelDelta;
      //滚动的数值 / 2000 => 表示滚动的比例，用此比例作为图片缩放的比例
      this.imgScaleHandle(dir / 6000);
    },
    imgScaleHandle(zoom) {
      /**
       * 图片的缩放
       * zoom >0 放大
       * zoom <0 缩小
       */
      // 缩放范围
      if(zoom > 0){
        if(this.multiples + 0.1 <= 3.05){
          let decimalPart = (this.multiples.toFixed(2)*10 - parseInt(this.multiples.toFixed(2)*10));
          this.multiples += 0.1 - decimalPart/10;
        }
      }else{
        if(this.multiples - 0.1 > 0.195 ){
          let decimalPart = (this.multiples.toFixed(2)*10 - parseInt(this.multiples.toFixed(2)*10));
          if(decimalPart === 0){
            this.multiples += -0.1
          }else{
            this.multiples += - decimalPart/10
          }
        }
      }
    },
    back(){
      this.showPreviewDialog = false
    },
    changeMediaIndex(action){
      if(action === 'last'){
        if(this.currentMediaIndex > 0){
          this.currentMediaIndex = this.currentMediaIndex - 1
        }
      }else{
        if(this.currentMediaIndex < this.mediaList.length - 1){
          this.currentMediaIndex = this.currentMediaIndex + 1
        }
      }
      this.$nextTick(()=>{
        this.top = document.body.clientHeight*0.2
        this.left = document.body.clientWidth*0.5
        this.deg = 0
        this.multiples = 1
        this.isFullScreen = false
        this.draggable = false
      })
    }
  },
}
</script>

<style lang="scss">
.changePage{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  background: rgba(166, 166, 166, 0.3);
  width: 34px;
  height: 34px;
  text-align: center;
&-icon{
   font-size: 18px;
   color: white;
   line-height: 34px;
   cursor: pointer
 }
}
</style>
